import swal from "sweetalert";
import { toast } from "react-toastify";

import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import bookclosurecss from "./../../css/bookclosure.module.css";
import Modal from "./../../elements/Modal";
import Dropdown from "./../../elements/Dropdown";
import { Button, IconButton } from "./../../elements/Button";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as TagIcon } from "../../assets/icons/tag.svg";
import { ReactComponent as ShortTextIcon } from "../../assets/icons/shorttext.svg";
import { ReactComponent as UserRoundIcon } from "../../assets/icons/user_round.svg";
import { ReactComponent as LongTextIcon } from "../../assets/icons/longtext.svg";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addBookClosureColumnsApiHandler } from "../../../Bookclosure/Services/ApiHandler";
import CreateColumnFieldModal from "./../../components/bookclosure/CreateColumnFieldModal";

const AddColumnsModal = ({
  companyId,
  bookClosureId,
  handleClose,
  setAddColumnsModal,
  getBookClosureData,
}) => {
  const dispatch = useDispatch();
  const [columnType, setColumnType] = useState(null);
  const [columnTitle, setColumnTitle] = useState(null);
  const [createColumnFieldModal, setCreateColumnFieldModal] = useState(false);

  const addBookClosureColumns = () => {
    const payload = {
      bookClosureID: bookClosureId,
      companyID: companyId,
      columnTitle: columnTitle,
      columnType: columnType,
    };
    addBookClosureColumnsApiHandler(payload)
      .then((response) => {
        getBookClosureData(companyId);
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to Book Closure Columns",
          "error"
        );
      });
  };

  const createColumnField = (columnType) => {
    setColumnType(columnType);
    setCreateColumnFieldModal(true);
  };
  return (
    <>
      <Modal
        width="45%"
        title="Add Columns"
        bodycss={commoncss.unsetPadding}
        headerActions={
          <CloseIcon
            onClick={() => {
              handleClose();
              setAddColumnsModal(false);
            }}
            className="clickable"
          />
        }
        onClose={() => console.log("Modal Closed")}
      >
        <div className={`${commoncss.pd1527}`}>
          <span className={commoncss.guidingLabel}>
            Add a new columns to your Checklist. Pick the type that best fits the information you want to add.
          </span>
          <span className={`${commoncss.gridContainer3} my-4`} style={{ padding: "0px" }}>
            <span className={commoncss.gridItem}>
              <IconButton
                class_="p-0"
                btnColor={buttoncss.secondary}
                icon={<CalenderIcon width={25} height={25} />}
                label="Date"
                onClick={() => {
                  createColumnField("date");
                }}
              />
            </span>
            <span className={commoncss.gridItem}>
              <IconButton
                class_="p-0"
                btnColor={buttoncss.secondary}
                icon={<TagIcon width={25} height={25} />}
                label="Tags"
                onClick={() => {
                  createColumnField("tag");
                }}
              />
            </span>
            <span className={commoncss.gridItem}>
              <IconButton
                class_="p-0"
                btnColor={buttoncss.secondary}
                icon={<ShortTextIcon width={25} height={25} />}
                label="Short Text"
                onClick={() => {
                  createColumnField("shortText");
                }}
              />
            </span>
            <span className={commoncss.gridItem}>
              <IconButton
                class_="p-0"
                btnColor={buttoncss.secondary}
                icon={<UserRoundIcon width={25} height={25} />}
                label="User"
                onClick={() => {
                  createColumnField("people");
                }}
              />
            </span>
            <span className={commoncss.gridItem}>
              <IconButton
                class_="p-0"
                btnColor={buttoncss.secondary}
                icon={<LongTextIcon width={25} height={25} />}
                label="Long Text"
                onClick={() => {
                  createColumnField("longText");
                }}
              />
            </span>
          </span>
        </div>
      </Modal>
      {createColumnFieldModal && (
        <CreateColumnFieldModal
          setCreateColumnFieldModal={setCreateColumnFieldModal}
          setColumnTitle={setColumnTitle}
          addBookClosureColumns={addBookClosureColumns}
        />
      )}
    </>
  );
};

export default AddColumnsModal;
